import TemplateView from '../../../../TemplateView'
import CopyAssignmentsFromButton from '../../CopyAssignmentsFromButton'
import CopyUserSelector from '../../CopyUserSelector'
import messageResource from '../../../../messageResource'
import CounterWithProgressBar from '../../../../components/counterCPT/CounterWithProgressBar'
import {CopyWorkAssignmentOptions, HierarchyLevels} from 'constants'
import {bindActionCreators} from 'redux'
import $ from 'jquery'
import {connect} from '../../../../redux/utils'
import {
    getCopySelectedOption,
    getCopyUserCounters,
    getCopyUserFrom,
    getCopyUserId,
    getPanelUserFML,
    getSelectorsUsers,
    isCopyLoading,
    isCopyUserAllScope,
    isViewerHasEntireScope,
} from '../selectors'
import {getTimeZoneGroups, getUserGroupsWithDefault} from '../../../../entities/selectors'
import {copyAssignments, loadUserCounters, setCopyOption} from '../actions'
import UserWithAccessRights from '../../../../store/UserWithAccessRights'
import SpinnerController from '../../../../SpinnerController'
import {isTZGEnabled, isUGREnabled} from '../../../../features/selectors'
import {customerNameLower, projectNameLower, taskNameLower} from '../../../../util/pluralizeUtils'

class CopyContent extends TemplateView {
    constructor({
        onCancel = () => {},
        onSelectUser = (userId) => {},
        onCopy = () => {},
        onOptionSelected = (option) => {},
    } = {}) {
        super()

        this.params = {
            onCancel,
            onSelectUser,
            onCopy,
            onOptionSelected,
        }

        this.state = {
            userId: null,
            userFrom: null,
            userTo: null,
            viewer: null,

            loading: false,
            counters: {
                tasks: 0,
                projects: 0,
                customers: 0,
            },
            isAllScopeToCopyUserFrom: false,
            isViewerHasEntireScope: true,

            selectedOption: null,

            users: [],
            ugrEnabled: true,
            userGroups: [],
            timeZoneGroups: [],
            tzgEnabled: true,
        }

        this.onStatePropertyChanged('userFrom', (userFrom) => {
            this.copyAssignmentsButton.setState({
                selectedUser: userFrom,
            })
        })

        this.onAnyStatePropertyChanged(['users', 'userGroups', 'timeZoneGroups', 'ugrEnabled', 'tzgEnabled'], () => {
            const usersWithAccessRights = this.state.users.map(userFrom => UserWithAccessRights.fromRPC(userFrom))

            this.copyUserSelector.setState({
                users: usersWithAccessRights,
                ugrEnabled: this.state.ugrEnabled,
                userGroups: Object.values(this.state.userGroups),
                tzgEnabled: this.state.tzgEnabled,
                timeZoneGroups: Object.values(this.state.timeZoneGroups),
            })
        })

        this.onAnyStatePropertyChanged(['userId', 'counters', 'isAllScopeToCopyUserFrom'], (state) => {
            const userId = state.userId
            const counters = state.counters
            const isCopyEnabled = userId !== null

            if(userId === null) {
                this.find('.commentNote').empty()
            }

            this.$taskCounter.toggle(!state.isAllScopeToCopyUserFrom)
            this.$projectCounter.toggle(!state.isAllScopeToCopyUserFrom)
            this.$customerCounter.toggle(!state.isAllScopeToCopyUserFrom)
            this.$allScope.toggle(!!state.isAllScopeToCopyUserFrom)

            if (!state.isAllScopeToCopyUserFrom && counters) {
                this.customerCounter.setState({
                    curValue: counters.customers,
                    maxValue: counters.customers,
                    title: messageResource.getMessage('userlist.work_assignments.active') + " " + customerNameLower(counters.customers),
                    active: counters.customers > 0,
                })

                this.projectCounter.setState({
                    curValue: counters.projects,
                    maxValue: counters.projects,
                    title: messageResource.getMessage('userlist.work_assignments.active') + " " + projectNameLower(counters.projects),
                    active: counters.projects > 0,
                })

                this.taskCounter.setState({
                    curValue: counters.tasks,
                    maxValue: counters.tasks,
                    title: messageResource.getMessage('userlist.work_assignments.open') + " " + taskNameLower(counters.tasks),
                    active: counters.tasks > 0,
                })
            }

            this.find('.radioSection .overwriteSection').toggleClass('disabled', !isCopyEnabled)
            this.find('.radioSection .appendSection').toggleClass('disabled', !isCopyEnabled)
            this.find('.radioSection .overwrite').prop('disabled', !isCopyEnabled)
            this.find('.radioSection .append').prop('disabled', !isCopyEnabled)
            // TODO bakharev: not toggle element just hide it
            this.find('.counters').toggle(isCopyEnabled)
        })

        this.onStatePropertyChanged('isViewerHasEntireScope', (isViewerHasEntireScope) => this.find('.counterSubtitle').toggle(!isViewerHasEntireScope))

        this.onStatePropertyChanged('selectedOption', (option) => {
            const selected = option !== null
            this.$copyButton.toggleClass('disabled', !selected)

            this.find('.radioSection .overwrite').prop('checked', option === CopyWorkAssignmentOptions.OVERWRITE)
            this.find('.radioSection .overwriteSection').toggleClass('selected', option === CopyWorkAssignmentOptions.OVERWRITE)
            this.find('.radioSection .append').prop('checked', option === CopyWorkAssignmentOptions.APPEND)
            this.find('.radioSection .appendSection').toggleClass('selected', option === CopyWorkAssignmentOptions.APPEND)
        })

        this.onStatePropertyChanged('loading', (loading) => {
            if (loading) {
                this.spinner.spinInElement(this.$spinner)
            } else {
                this.spinner.stop()
            }
        });

        this.onAnyStatePropertyChanged(['selectedOption', 'userFrom'], () => this._updateCommentNote())
    }

    templateHtml() {
        return '<div class="copyContent">' +
               '  <div class="title"><%-title%></div>' +
               '  <div class="userSelector"/>' +
               '  <div class="spinner"/>' +
               '  <div class="counters">' +
               '    <div class="title"><%-counterTitle%></div>' +
               '    <div class="customers"></div>' +
               '    <div class="projects"></div>' +
               '    <div class="tasks"></div>' +
               '    <div class="allScope"><%-entireScope%></div>' +
               '  </div>' +
               '  <div class="counterSubtitle"><%-counterSubtitle%></div>' +
               '  <div class="optionsTitle"><%-optionsTitle%></div>' +
               '  <div class="radioSection">' +
               '    <label>' +
               '        <div class="overwriteSection">' +
               '            <input type="radio" class="overwrite"/>' +
               '            <span><%-overwrite%></span>' +
               '        </div>' +
               '    </label>' +
               '    <label>' +
               '        <div class="appendSection">' +
               '            <input type="radio" class="append"/>' +
               '            <span><%-append%></span>' +
               '        </div>' +
               '    </label>' +
               '  </div>' +
               '  <div class="disableRadioChoose"/>' +
               '  <div class="commentNote"/>' +
               '  <div class="buttonsSection">' +
               '    <div class="copyButton"><%-copy%></div>' +
               '    <div class="cancelButton"><%-cancel%></div>' +
               '  </div>' +
               '</div>'
    }

    templateModel() {
        return {
            title: messageResource.getMessage('work_assignments.panel.copy.title'),
            entireScope: messageResource.getMessage('user_list.table.manage_scope.entire_scope'),
            counterTitle: messageResource.getMessage('work_assignments.panel.copy.counter_title'),
            optionsTitle: messageResource.getMessage('work_assignments.panel.copy.options.title'),
            overwrite: messageResource.getMessage('work_assignments.panel.copy.options.overwrite'),
            append: messageResource.getMessage('work_assignments.panel.copy.options.append'),
            copy: messageResource.getMessage('common.copy'),
            cancel: messageResource.getMessage('common.cancel'),
            counterSubtitle: messageResource.getMessage('work_assignments.panel.copy.counters.subtitle'),
        }
    }

    afterRender() {
        this.$userSelector = this.find('.userSelector')
        this.$countersSection = this.find('.counters')
        this.$allScope = this.find('.counters .allScope')
        this.$copyButton = this.find('.copyButton')
        this.$cancelButton = this.find('.cancelButton')

        this.$cancelButton.click(() => {
            this.find('.commentNote').empty()
            this.params.onCancel()
        })

        this.$copyButton.click(() => {
            if (this.state.selectedOption !== null) {
                this.params.onCopy()
            }
        })

        this.copyUserSelector = new CopyUserSelector({
            title: messageResource.getMessage("user.add.js.copy_setting.selector.label"),
            selectionCallback: (user) => {
                this.params.onSelectUser(user.id)
                this.copyUserSelector.hide()
            },
            showPermissionIcons: false,
            renderTo: this.getEl(),
        }).init()

        this.$customerCounter = this.find('.counters .customers')
        this.customerCounter = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.CUSTOMER,
        }).init(this.$customerCounter)
        this.customerCounter.setState({pale: true})

        this.$projectCounter = this.find('.counters .projects')
        this.projectCounter = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.PROJECT,
        }).init(this.$projectCounter)
        this.projectCounter.setState({pale: true})

        this.$taskCounter = this.find('.counters .tasks')
        this.taskCounter = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.TASK,
        }).init(this.$taskCounter)
        this.taskCounter.setState({pale: true})

        this.copyAssignmentsButton = new CopyAssignmentsFromButton().init(this.$userSelector)
        this.copyAssignmentsButton.bindClick(() => this.copyUserSelector.showAt(this.copyAssignmentsButton.$el, "t-b"))

        this.find('.radioSection .appendSection').change((e) => {
            e.preventDefault()
            if (this._copyEnabled()) {
                this.params.onOptionSelected(CopyWorkAssignmentOptions.APPEND)
            }
        })

        this.find('.radioSection .overwriteSection').change((e) => {
            e.preventDefault()
            if (this._copyEnabled()) {
                this.params.onOptionSelected(CopyWorkAssignmentOptions.OVERWRITE)
            }
        })

        this.$spinner = this.find('.spinner');
        this.spinner = new SpinnerController();

        this.renderInitialState()
    }

    _copyEnabled() {
        return this.state.userId !== null
    }

    _updateCommentNote() {
        if(this.state.userFrom && this.state.userTo) {

            const option = this.state.selectedOption

            const userFromFirstName = this.state.userFrom.firstName
            const userToFirstName = this.state.userTo.firstName

            const $commentNote = this.find('.commentNote').empty()
            if (option === CopyWorkAssignmentOptions.OVERWRITE) {

                if (this.state.isViewerHasEntireScope) {
                    $commentNote.append($('<div>' + messageResource.getEscapedMessage('work_assignments.panel.copy.options.overwrite.description_part1.with_entire_scope',
                        [userFromFirstName, userToFirstName]) + '</div>' +
                                          '<div class="part2">' + messageResource.getMessage('work_assignments.panel.copy.options.overwrite.description_part2') + '</div>'))
                }
                else {
                    $commentNote.append($('<div>' + messageResource.getMessage('work_assignments.panel.copy.options.overwrite.description_part1',
                        [userFromFirstName, userToFirstName]) + '</div>' +
                                          '<div class="additionalText">' + messageResource.getMessage('work_assignments.panel.copy.options.overwrite.description_part2') + '</div>'))
                }
            } else if (option === CopyWorkAssignmentOptions.APPEND) {
                $commentNote.append($('<div>' + messageResource.getEscapedMessage('work_assignments.panel.copy.options.append.description', [userFromFirstName, userToFirstName]) + '</div>'))
            }
        }
    }
}


export default connect(
    state => ({
        userId: getCopyUserId(state),
        userFrom: getCopyUserFrom(state),
        userTo: getPanelUserFML(state),

        loading: isCopyLoading(state),
        counters: getCopyUserCounters(state),
        isAllScopeToCopyUserFrom: isCopyUserAllScope(state),
        isViewerHasEntireScope: isViewerHasEntireScope(state),
        selectedOption: getCopySelectedOption(state),

        users: getSelectorsUsers(state),
        ugrEnabled: isUGREnabled(state),
        userGroups: getUserGroupsWithDefault(state),
        tzgEnabled: isTZGEnabled(state),
        timeZoneGroups: getTimeZoneGroups(state),
    }),
    dispatch => ({
        onSelectUser: bindActionCreators(loadUserCounters, dispatch),
        onCopy: bindActionCreators(copyAssignments, dispatch),
        onOptionSelected: bindActionCreators(setCopyOption, dispatch),
    })
)(CopyContent)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentPanel/components/CopyContent.js